import React, { useState, useEffect, useCallback } from 'react';
import { MenuDrawer, ScrollContainer, ModalBody, DesignModal } from '../LandingPage/styles';
import {
  AdvSearchIcon,
  Container,
  LoaderContainer,
  TemplateConatiner,
  ContentSection,
  EmptySettingsDetails,
  FilterTitle,
  SearchBar,
  SearchTitle,
  TemplateImage,
  TemplatePageOverview,
  TemplateTitleSec,
  TemplateWrapper,
  UploadSteps,
} from '../TemplateSection/styles';
import { Button, Checkbox, Icon, Input, Steps, Tooltip, message } from 'antd';
import {
  ADVANCED_FILTER,
  TRANSACTIONS,
  EMAIL_TRANSACTIONS,
} from '../TemplateSection/translationValues';
import Lottie from 'react-lottie';
import _ from 'underscore';
import { withTranslation } from 'react-i18next';
import EmptyElementsIllustration from '../../images/empty-elements.svg';
import { SendEmailIcon } from '../../../src/images/svgIcons';
import { emailAnimationData } from '../TemplateSection/lottieFiles';
import Loader from '../../components/Loader';
import {
  FetchEmailTemplatesBycategory,
  getPublishedEmailTemplates,
} from '../../utils/services/complexEmailAPI';
import AddTags from '../TemplateSection/tagSearch';
import UploadSection from './UploadSection';

const { Step } = Steps;
const { Search } = Input;
const CheckboxGroup = Checkbox.Group;

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: emailAnimationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const ComplexEmailTransactions = props => {
  const { t } = props;

  const [currentStep, setCurrentStep] = useState(0);

  const [showDrawer, setShowDrawer] = useState(false);
  const [drawAnimate, setDrawAnimate] = useState(false);
  const [showSearchIcon, setShowSearchIcon] = useState(false);
  const [showCategories, setShowCategories] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [fetchingCategoryList, setFetchingCategoryList] = useState(true);
  const [isScrollToTop, setIsScrollToTop] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const [tempListByCategory, setTempListByCategory] = useState([]);
  const [templatesList, setTemplatesList] = useState([]);
  const [totalTemplates, setTotalTemplates] = useState(null);
  const [page, setPage] = useState(1);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
  const [searchedTags, setSearchedTags] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [searchKey, setSearchKey] = useState('');
  const [removeAllTags, setRemoveAllTags] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  useEffect(() => {
    fetchPublishedTemplatesByCategory();
  }, []);

  useEffect(() => {
    fetchPublishedTemplates();
    setInitialized(true);
  }, [page]);

  useEffect(() => {
    if (page === 1 && initialized) {
      fetchPublishedTemplates();
    } else {
      setPage(1);
    }
  }, [searchKey, selectedCategoryIds, searchedTags]);

  const fetchPublishedTemplatesByCategory = async () => {
    setFetchingCategoryList(true);
    try {
      const response = await FetchEmailTemplatesBycategory();
      if (response?.statusCode === 707) {
        setTempListByCategory(response.data || []);
      } else {
        message.error(
          t(
            TRANSACTIONS.FETCH_TEMPLATES_BY_CATEGORY_ERROR_MESSAGE.key,
            TRANSACTIONS.FETCH_TEMPLATES_BY_CATEGORY_ERROR_MESSAGE.value,
          ),
        );
      }
    } catch (e) {
      console.error(e);
    } finally {
      setFetchingCategoryList(false);
    }
  };

  const fetchPublishedTemplates = async () => {
    if (page === 1) {
      setIsLoading(true);
    }
    try {
      const response = await getPublishedEmailTemplates({
        page: page,
        limit: 12,
        includeVariables: true,
        ...(searchKey && { name: searchKey }),
        ...(selectedCategoryIds.length > 0 && { categoryIds: selectedCategoryIds }),
        ...(searchedTags.length > 0 && { tags: searchedTags }),
      });
      if (response?.statusCode === 707) {
        if (page === 1) {
          setTemplatesList(response.data || []);
          setTotalTemplates(response.dataCount || 0);
        } else {
          const mergedTemplates = templatesList.concat(response.data);
          setTemplatesList(mergedTemplates);
        }
      } else {
        message.error(
          t(
            TRANSACTIONS.FETCH_PUBLISHED_TEMPLATES_ERROR_MESSAGE.key,
            TRANSACTIONS.FETCH_PUBLISHED_TEMPLATES_ERROR_MESSAGE.value,
          ),
        );
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const showDraw = () => {
    setShowDrawer(true);
    setTimeout(() => {
      setShowSearchIcon(true);
    }, 1000);
  };
  const hideDraw = () => {
    setShowDrawer(false);
    setDrawAnimate(true);
    setShowSearchIcon(false);
    setTimeout(() => {
      setDrawAnimate(false);
    }, 1800);
  };

  const getCategoryOptions = all => {
    if (all) {
      return tempListByCategory.map(item => ({
        label: item.categoryName,
        value: item.categoryId,
      }));
    } else {
      return tempListByCategory.slice(0, 5).map(item => ({
        label: item.categoryName,
        value: item.categoryId,
      }));
    }
  };

  const steps = [
    {
      title: (
        <div>
          {t(
            TRANSACTIONS.SELECT_A_TEMPLATE_STEP_TITLE.key,
            TRANSACTIONS.SELECT_A_TEMPLATE_STEP_TITLE.value,
          )}{' '}
          <br />
        </div>
      ),
    },
    {
      title: t(
        TRANSACTIONS.UPLOAD_EXCEL_FILE_STEP_TITLE.key,
        TRANSACTIONS.UPLOAD_EXCEL_FILE_STEP_TITLE.value,
      ),
    },
  ];

  const templateList = () => {
    return (
      <>
        <TemplateTitleSec isPublishedTemp={1}>
          <p className={'template_title'}>
            {t(
              `EMAIL_TRANSACTIONS:${EMAIL_TRANSACTIONS.EMAIL_TRANSACTIONS_TITLE.key}`,
              EMAIL_TRANSACTIONS.EMAIL_TRANSACTIONS_TITLE.value,
            )}
          </p>
        </TemplateTitleSec>
        {isLoading ? (
          <LoaderContainer style={{ marginTop: '25%' }}>
            <Loader />
          </LoaderContainer>
        ) : templatesList?.length > 0 ? (
          <>
            <TemplateWrapper isUploadFile={1}>
              {templatesList.map(templateObj => {
                return (
                  <div key={templateObj.id}>
                    <div>
                      <TemplatePageOverview
                        uploadExcel={1}
                        className={
                          selectedTemplate && selectedTemplate.id === templateObj.id && 'selected'
                        }
                        key={templateObj.id}
                        title={templateObj.name}
                        onClick={() => {
                          showDrawer && hideDraw();
                          setSelectedTemplate(templateObj);
                          setCurrentStep(1);
                        }}
                      >
                        <TemplateImage uploadExcel={1}>
                          <Icon component={SendEmailIcon} />
                        </TemplateImage>
                        <div className="template_name">
                          <div className="name">{templateObj.name}</div>
                          <div className="categoryName">
                            <div className="box2"></div>
                            {tempListByCategory.length > 0 &&
                              tempListByCategory.map(
                                category =>
                                  templateObj.categoryId === category.categoryId && (
                                    <div className="categ_Name" key={category.categoryId}>
                                      {category.categoryName}
                                    </div>
                                  ),
                              )}
                          </div>
                        </div>
                      </TemplatePageOverview>
                    </div>
                  </div>
                );
              })}
            </TemplateWrapper>
          </>
        ) : (
          <EmptySettingsDetails style={{ marginTop: '200px' }}>
            <div className="empty-illustration">
              <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
            </div>
            <div className="empty-txt">
              <span>
                {t(
                  TRANSACTIONS.NO_TEMPLATES_AVAILABLE_TEXT.key,
                  TRANSACTIONS.NO_TEMPLATES_AVAILABLE_TEXT.value,
                )}
              </span>
            </div>
          </EmptySettingsDetails>
        )}
      </>
    );
  };

  const handleScroll = useCallback(() => {
    const reference = document.querySelector('#scrollContainer');
    if (reference) {
      if (reference.classList.contains('on-scrollbar') === false) {
        reference.classList.add('on-scrollbar');
      } else {
        setTimeout(() => {
          if (document.querySelector('#scrollContainer')) {
            document.querySelector('#scrollContainer').classList.remove('on-scrollbar');
          }
        }, 500);
      }
      if (
        reference.scrollTop !== 0 &&
        reference.scrollHeight - 40 - reference.scrollTop - reference.clientHeight <= 1
      ) {
        setPage(page + 1);
      }
      if (reference.scrollTop > 800) {
        setIsScrollToTop(true);
      } else {
        setIsScrollToTop(false);
      }
    }
  }, [page]);

  const smoothScroll = () => {
    document.querySelector('#scrollContainer').scrollTop = 0;
  };

  const clearAllFilters = (tags, clearFilters) => {
    if (clearFilters) {
      setSearchKey('');
      setSelectedCategoryIds([]);
      setSearchedTags([]);
    } else {
      setSearchedTags(tags);
    }
  };

  return (
    <ScrollContainer
      onScroll={_.debounce(handleScroll, 500)}
      id="scrollContainer"
      uploadCurrent={currentStep > 0}
      isUploadFile={1}
    >
      <Container isUploadFile={1}>
        {currentStep === 0 && (
          <Tooltip
            placement="left"
            title={
              !showDrawer &&
              t(
                `ADVANCED_FILTER:${ADVANCED_FILTER.ADVANCED_FILTER_TITLE.key}`,
                ADVANCED_FILTER.ADVANCED_FILTER_TITLE.value,
              )
            }
          >
            <AdvSearchIcon
              type={showDrawer ? 'close' : 'search'}
              showSearchIcon={showDrawer && showSearchIcon}
              onClick={() => (showDrawer ? hideDraw() : showDraw())}
            />
          </Tooltip>
        )}

        <DesignModal
          categ={true}
          title={
            <p>
              {t(
                `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_CATEGORY_LABEL.key}`,
                ADVANCED_FILTER.FILTER_BY_CATEGORY_LABEL.value,
              )}
              <div className="badge">{tempListByCategory?.length}</div>
            </p>
          }
          centered
          visible={showCategories}
          onOk={() => setShowCategories(false)}
          onCancel={() => setShowCategories(false)}
          footer={null}
          mask={false}
          className={'design_modal_categ'}
        >
          <ModalBody>
            <CheckboxGroup
              options={getCategoryOptions(true)}
              value={selectedCategoryIds}
              onChange={e => setSelectedCategoryIds(e)}
            />
          </ModalBody>
        </DesignModal>

        <MenuDrawer
          SearchDrawer={true}
          className={showDrawer ? 'drawVisible' : drawAnimate ? 'drawAnimate' : 'drawInVisible'}
        >
          <div className={!showDrawer ? 'switch' : 'switch_searchBar'} />
          <div className="searchDrawer">
            {showDrawer && (
              <ContentSection>
                <SearchTitle>
                  {t(
                    `ADVANCED_FILTER:${ADVANCED_FILTER.ADVANCED_FILTER_TITLE.key}`,
                    ADVANCED_FILTER.ADVANCED_FILTER_TITLE.value,
                  )}
                </SearchTitle>
                <FilterTitle
                  className={'clearFilter'}
                  onClick={() => setRemoveAllTags(!removeAllTags)}
                >
                  {t(
                    `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_CLEAR_ALL.key}`,
                    ADVANCED_FILTER.FILTER_CLEAR_ALL.value,
                  )}
                </FilterTitle>
                <FilterTitle>
                  {' '}
                  {t(
                    `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_NAME_LABEL.key}`,
                    ADVANCED_FILTER.FILTER_BY_NAME_LABEL.value,
                  )}
                </FilterTitle>
                <SearchBar className={'focused'}>
                  <Search
                    autoComplete="off"
                    name="nameSearch"
                    placeholder={t(
                      `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_NAME_PLACEHOLDER.key}`,
                      ADVANCED_FILTER.FILTER_BY_NAME_PLACEHOLDER.value,
                    )}
                    onSearch={e => setSearchKey(e)}
                    onChange={e => setSearchValue(e.target.value)}
                    allowClear
                    value={searchValue}
                  />
                </SearchBar>
                <FilterTitle>
                  {t(
                    `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_CATEGORY_LABEL.key}`,
                    ADVANCED_FILTER.FILTER_BY_CATEGORY_LABEL.value,
                  )}
                </FilterTitle>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '100%',
                  }}
                >
                  {fetchingCategoryList ? (
                    <Icon type="loading" />
                  ) : tempListByCategory.length > 0 ? (
                    <>
                      <CheckboxGroup
                        options={getCategoryOptions(false)}
                        value={selectedCategoryIds}
                        onChange={e => setSelectedCategoryIds(e)}
                      />
                      {tempListByCategory.length > 5 && (
                        <div
                          onClick={() => setShowCategories(true)}
                          style={{
                            fontFamily: 'Raleway,sans-serif',
                            fontSize: '15px',
                            fontWeight: 700,
                            marginTop: '10px',
                            cursor: 'pointer',
                            color: 'rgb(219,57,31) ',
                          }}
                        >
                          {`+${tempListByCategory.length - 5}` +
                            ' ' +
                            t(
                              `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_SHOW_ALL_CATEGORIES_ACTION.key}`,
                              ADVANCED_FILTER.FILTER_SHOW_ALL_CATEGORIES_ACTION.value,
                            )}
                        </div>
                      )}
                    </>
                  ) : (
                    <EmptySettingsDetails>
                      <div className="empty-illustration">
                        <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
                      </div>
                      <div className="empty-txt" style={{ color: '#fff' }}>
                        <span>
                          {t(
                            `ADVANCED_FILTER:${ADVANCED_FILTER.EMPTY_CATEGORIES_LIST.key}`,
                            ADVANCED_FILTER.EMPTY_CATEGORIES_LIST.value,
                          )}
                        </span>
                      </div>
                    </EmptySettingsDetails>
                  )}
                </div>
                <>
                  <FilterTitle>
                    {t(
                      `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_TAGS_LABEL.key}`,
                      ADVANCED_FILTER.FILTER_BY_TAGS_LABEL.value,
                    )}
                  </FilterTitle>
                  <AddTags
                    globalTagSearch={clearAllFilters}
                    clearALLTags={removeAllTags}
                    placeholder={t(
                      `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_TAGS_PLACEHOLDER.key}`,
                      ADVANCED_FILTER.FILTER_BY_TAGS_PLACEHOLDER.value,
                    )}
                  />
                </>
              </ContentSection>
            )}
          </div>
        </MenuDrawer>

        <TemplateConatiner isUploadFile={1}>
          <div>
            <UploadSteps currentStep={currentStep > 0}>
              <Steps current={currentStep} direction="vertical">
                {steps.map(item => (
                  <Step key={item.title} title={item.title} />
                ))}
                <Lottie
                  options={defaultOptions}
                  className="lottie"
                  height="40%"
                  width="50%"
                  style={{ marginTop: '50%' }}
                  speed={0.3}
                  isStopped={false}
                  isPaused={false}
                />
              </Steps>
              <div className="uploadSection">
                <div className="steps-content" style={{ width: '70vw' }}>
                  {currentStep === 0 && templateList()}
                  {currentStep === 1 && <UploadSection selectedTemplate={selectedTemplate} />}
                </div>
                <div
                  className={`${currentStep > 0 ? 'previous steps-action' : 'next steps-action'}`}
                >
                  {currentStep > 0 && (
                    <Button
                      style={{ marginLeft: 8 }}
                      onClick={() => {
                        setCurrentStep(0);
                      }}
                    >
                      {t(
                        TRANSACTIONS.MOVE_TO_SELECT_A_TEMPLATE_STEP_BUTTON.key,
                        TRANSACTIONS.MOVE_TO_SELECT_A_TEMPLATE_STEP_BUTTON.value,
                      )}
                    </Button>
                  )}
                </div>
              </div>
            </UploadSteps>
          </div>
          {!isLoading && currentStep === 0 && templatesList?.length > 0 && (
            <>
              {templatesList?.length !== totalTemplates && templatesList.length >= 6 && (
                <div className="addMore">
                  <Icon type="loading" />
                  {t(
                    TRANSACTIONS.LOADING_MORE_TEMPLATES_MESSAGE.key,
                    TRANSACTIONS.LOADING_MORE_TEMPLATES_MESSAGE.value,
                  )}
                </div>
              )}
              {templatesList?.length === totalTemplates && templatesList.length !== 0 && (
                <div className="allData">
                  {t(
                    TRANSACTIONS.GOT_ALL_TEMPLATES_MESSAGE.key,
                    TRANSACTIONS.GOT_ALL_TEMPLATES_MESSAGE.value,
                  )}
                </div>
              )}
            </>
          )}
        </TemplateConatiner>
      </Container>
      {isScrollToTop && currentStep === 0 && (
        <Tooltip placement="left" title={'Scroll to top'}>
          <Icon type="arrow-up" onClick={() => smoothScroll()} />
        </Tooltip>
      )}
    </ScrollContainer>
  );
};

const NAMESPACES = ['TRANSACTIONS', 'EMAIL_TRANSACTIONS', 'ADVANCED_FILTER'];

export default withTranslation(NAMESPACES)(ComplexEmailTransactions);
